export enum PackageItemTypeCategory {
    Realty = 1,
    Household = 2,
    Basic = 3,
    Addons = 4
}